import SectionHeading from "@/components/base/SectionHeading";
import { brandValues } from "@/mocks/posts";

export default function BrandSection() {
  return (
    <section id="about" className="mx-auto w-full max-w-container scroll-mt-24 px-4 md:px-6 py-16 md:py-20">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <SectionHeading
            eyebrow="About"
            title="关于99看料"
            desc="我们想做的其实很简单：给每一条值得被看见的线索，配一个能好好讨论的地方。"
          />

          <div className="mt-7 space-y-4 text-sm md:text-base leading-relaxed text-foreground-600">
            <p>
              99看料是一个由用户共同书写的内容社区。这里的线索来自真实的生活现场——通勤路上的一次偶遇、消费时的一次踩坑、职场上的一段观察，都值得被记录和讨论。
            </p>
            <p>
              我们不追求最快，也不追求最刺激。比起抢先一步下结论，我们更在意内容是否经得起推敲，评论区是否留下了有价值的不同声音。
            </p>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a
              href="mailto:hello@99kanliao.example"
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-send-line text-base" aria-hidden="true" />
              留言反馈
            </a>
            <span className="font-label text-sm text-foreground-600">hello@99kanliao.example</span>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-7">
          {brandValues.map((value) => (
            <div key={value.title} className="rounded-lg border border-background-200 bg-background-100 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${value.icon} text-2xl`} aria-hidden="true" />
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{value.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{value.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}